<template>
  <sidebar>
    <v-form class="col-md-12 p-5">
      <h4 class="text-center mb-0">Cadastro de Criador</h4>
      <v-divider class="mb-7"></v-divider>
      <v-text-field 
        outlined
        label="Nome"
        v-model="person.name"
      />
      <v-text-field 
        outlined
        label="CPF"
        v-model="person.doc"
      />
      <v-text-field 
        outlined
        label="Email"
        v-model="person.email"
        :error-messages="emailErrors"
      />
      <v-text-field 
        :key="inputKey"
        outlined
        label="Telefone"
        v-model="person.phone"
        :autofocus="inputKey > 0 ? true : false"
      />
      <div class="col-md-12 d-flex justify-content-between">
        <div class="col-md-9">
          <v-text-field 
            outlined
            label="Endereço"
            v-model="person.address"
          />
        </div>
        <div class="col-md-2">
          <v-text-field 
            outlined
            label="Nº"
            v-model="person.number"
          />
        </div>
      </div>
      <v-text-field 
        outlined
        label="Bairro"
        v-model="person.district"
      />
      <v-text-field 
        outlined
        label="CEP"
        v-model="person.zipcode"
      />
      <v-divider></v-divider>
      <h5 class="text-center">Parleite</h5>
      <p class="parleite-status" :class="{'parleite-status--ok': person.has_parleite_token}">
        <i :class="`mdi ${person.has_parleite_token ? 'mdi-check-circle' : 'mdi-alert-circle-outline'}`"></i>
        {{person.has_parleite_token ? "Token cadastrado" : "Sem token: a consulta de análises da Parleite não funciona para este criador"}}
      </p>
      <v-text-field
        outlined
        type="password"
        autocomplete="new-password"
        :label="person.has_parleite_token ? 'Novo token da Parleite (em branco mantém o atual)' : 'Token da Parleite'"
        hint="Fornecido pela Parleite ao criador, conforme a adesão. Fica guardado de forma protegida e não é exibido de novo."
        persistent-hint
        :disabled="!!person.remove_parleite_token"
        v-model="person.parleite_token"
      />
      <v-checkbox
        v-if="person.has_parleite_token"
        dense
        label="Remover o token cadastrado"
        v-model="person.remove_parleite_token"
      />
      <v-divider></v-divider>
      <h5 class="text-center">Status</h5>
      <div class="col-md-12 d-flex justify-content-evenly">
        <div class="col-md-4 d-flex align-items-center align-items-center">
          <v-switch
            :key="switchKey"
            @change="checkSwitch"
            inset
            color="var(--green)"
            label="Ativo"
            v-model="person.is_active"
          ></v-switch>
        </div>
        <div class="col-md-4 d-flex align-items-center align-items-center">
          <v-switch
            :key="switchKey"
            @change="checkSwitch"
            inset
            color="var(--green)"
            label="Inativo"
            v-model="person.inactive"
          ></v-switch>
        </div>
        <div class="col-md-4 d-flex align-items-center align-items-center">
          <v-switch
            :key="switchKey"
            @change="checkSwitch"
            inset
            color="var(--green)"
            label="Não Habilitado"
            v-model="person.not_available"
          ></v-switch>
        </div>
      </div>
      <!-- <v-select 
        outlined
        label="Permissão"
        :items="permissions"
        item-text="text"
        item-value="value"
      /> -->
      <v-text-field
        v-if="person.is_active"
        label="Senha"
        outlined
        v-model="person.password"
      ></v-text-field>
      <div class="col-md-12">
        <div class="col-md-6 d-flex">
          <v-btn 
            class="success"
            @click="save"
          >
            Salvar
          </v-btn>
          <v-btn 
            @click="$emit('close')"
            outlined class="btn-back ml-5"
          >
            Voltar
          </v-btn>
        </div>
      </div>
    </v-form>
  </sidebar>
</template>

<script>
import Sidebar from "@/components/layout/Sidebar.vue";
import {mapActions} from "vuex";
export default {
  name:"SidebarCreators",
  props: {
    creatorEdit:Object
  },
  components: {
    Sidebar
  },
  data() {
    return {
      person:{
        classname:"creator"
      },
      inputKey:0,
      switchKey:0
    }
  },
  computed: {
    /* permissions() {
      return [
         {text:"Controlador", value: "pesagem"},
         {text:"Supervisor", value: "supervisao"},
      ]
    } */
    emailErrors() {
      if(!this.person.email || !this.person.email.length) {
        return "Email é obrigatório";
      } else {
        return ""
      }
    }
  },
  methods: {
    ...mapActions("creators", ["actionSaveCreator", "actionEditCreator"]),
    checkSwitch() {
      if(this.person.is_active) {
        this.person.inactive = false;
        this.person.not_available = false;
      }
      else if(this.person.inactive) {
        this.person.is_active = false;
        this.person.not_available = false;
      }
      else if(this.person.not_available) {
        this.person.is_active = false;
        this.person.inactive = false;
      }
      this.switchKey = this.switchKey + 1;
    },
    checkNumber(val) {
      if(val == null) return;
      if(isNaN(val)) {
        this.inputKey = this.inputKey + 1;
        let filtered = val.toString().split("").filter(e => 
        e === "1" || e === "2" || e === "3" ||
        e === "4" || e === "5" || e === "6" ||
        e === "7" || e === "8" || e === "9"
        )
        this.person.phone = filtered.join().replaceAll(",","");
      }
    },
    async save() {
      if(this.emailErrors.length) {
        this.$toast.warning("Email é obrigatório");
        return
      }
      if(this.person.is_active) {
        this.person.status = "active";
        this.person.active = true
      }
      if(this.person.inactive) {
        this.person.status = "inactive";
        this.person.active = false;
      }
      if(this.person.not_available) {
        this.person.status = "no_access";
        this.person.active = true;
      }
      // os switches ficam no formulário (se o back recusar, o usuário corrige e tenta de novo)
      const payload = {...this.person};
      ["is_active", "inactive", "not_available", "has_parleite_token"].forEach(k => delete payload[k]);
      // token só vai quando digitado (em branco mantém o atual no servidor)
      payload.parleite_token = (payload.parleite_token || "").trim();
      if(!payload.parleite_token) delete payload.parleite_token;
      await this.submit(this.person.id ? this.actionEditCreator : this.actionSaveCreator, payload);
    },
    // fecha só no sucesso; erro de validação do back ({campo: [mensagens]}) vira um toast por campo
    async submit(action, payload) {
      try {
        await action(payload);
        this.$emit('close');
      } catch(error) {
        const data = (error.response && error.response.data) || {};
        const labels = {parleite_token: "Token da Parleite"};
        Object.entries(typeof data === "object" ? data : {}).forEach(([field, msgs]) => this.$toast.error(`${labels[field] || field} ${[].concat(msgs)[0]}`));
      }
    },
  },
  watch: {
    "person.phone": function(val) {
      this.checkNumber(val);
    },
    "creatorEdit.id": function() {
      this.person = {...this.creatorEdit, is_active: this.creatorEdit.active}
    }
  }
}
</script>

<style scoped>
  .parleite-status {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 4px 0 14px;
    font-size: .85rem;
    color: var(--muted);
  }
  .parleite-status--ok {
    color: #2e7d32;
  }
  .parleite-status i {
    font-size: 1.1rem;
  }
</style>
